"use client";

import { Button, ButtonProps } from "@repo/ui/button";
import { MicrosoftIcon } from "@repo/icons";
import { cn } from "../../lib/utils";
import { signIn } from "../../lib/auth-client";

export const MicrosoftSignInButton = ({
  className,
  ...props
}: Omit<ButtonProps, "onClick" | "children">) => {
  return (
    <Button
      {...props}
      className={cn(
        "bg-white! border-[#8C8C8C]! px-[12px]! gap-0! text-[#5E5E5E]! border active:bg-[#5F5F5f]! hover:text-white! hover:bg-[#2F2F2F]! active:text-white!",
      )}
      onClick={() => {
        signIn.social({
          provider: "microsoft",
          callbackURL: "/files",
        });
      }}
    >
      <MicrosoftIcon className="mr-[12px]" /> Sign in with microsoft
    </Button>
  );
};
